<template>
  <div class="freePath-edit" v-show="isShow" @keydown.stop @mousedown.stop>
    <div
      class="mask-all"
      :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}"
    ></div>
    <!-- 元素dom,svg路径,吸附线,路径点操作 -->
    <div class="path-canvas" :style="pathCanvasStyle">
      <div class="sprite-content" :class="{'playing': status=== 'play'}" :style="contentStyle">
        <div class="content" v-html="contentHTML" ref="currentContent"></div>
      </div>
      <div id="freePathEdit"></div>
      <div class="auxiliary_line_box">
        <div v-show="middleData.show" class="net_line_middle" :style="middleStyle"></div>
        <div v-show="centerData.show" class="net_line_center" :style="centerStyle"></div>
      </div>
      <div
        v-dragWhole
        class="free-path-control"
        @mousemove="controlMove"
        @dblclick="controlDbClick"
      >
        <div
          class="first-point"
          data-action="firstPoint"
          v-if="status === 'paint'"
          :style="{left: firstP[0] - 4 + 'px', top: firstP[1] - 4 + 'px'}"
        ></div>
        <div class="point-box" v-if="status === 'edit'">
          <div v-for="(p, i) in point">
            <div
              v-if="type === 'bessel'"
              class="left-point"
              :data-action="'pointLeft-' + i"
              :style="{left: p[0] - 4 + 'px', top: p[1] - 4 + 'px'}"
            ></div>
            <div
              class="center-point"
              :class="{active: i === pIndex}"
              :data-action="'pointCenter-' + i"
              :style="{left: p[2] - 4 + 'px', top: p[3] - 4 + 'px'}"
            ></div>
            <div
              v-if="type === 'bessel'"
              class="right-point"
              :data-action="'pointRight-' + i"
              :style="{left: p[4] - 4 + 'px', top: p[5] - 4 + 'px'}"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 直线和曲线按钮和提示 -->
    <div class="button-box" :style="buttonBoxStyle">
      <div :class="{'active': type === 'line'}" @click="changeType('line', true)">直线</div>
      <div :class="{'active': type === 'bessel'}" @click="changeType('bessel', true)">曲线</div>
      <el-tooltip placement="right" :open-delay="500">
        <div slot="content" style="font-size: 15px">
          <p>1、单击鼠标：对路径进行打点</p>
          <p>2、拖拽鼠标：曲线模式下打点的同时按住鼠标拖拽可直接完成曲线的绘制</p>
          <p>3、双击鼠标、闭合起点或ESC：结束路径绘制模式，并同时进入编辑模式</p>
          <p>4、曲线模式：选中控制点拖拽出辅助点可形成曲线路径</p>
        </div>
        <div v-show="status === 'paint'" class="tip-icon">?</div>
      </el-tooltip>
    </div>
    <div v-if="status === 'edit'" class="box-exit" :style="boxExitStyle">
      <div class="active" @click="savePath()">完成</div>
      <div @click="cancel(true)">取消</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "freePathEdit",
  data() {
    return {
      ANALYSIS: {
        line: {
          category: "route_animation",
          action: "click_free_path_straight",
          label: "路径动画_点击_自由路径_直线"
        },
        bessel: {
          category: "route_animation",
          action: "click_free_path_curve",
          label: "路径动画_点击_自由路径_曲线"
        },
        drag: {
          category: "route_animation",
          action: "drag_free_path_curve_ctrlpois",
          label: "路径动画_拖拽_自由路径_曲线_控制点"
        },
        finish: {
          category: "route_animation",
          action: "finish_path_poi",
          label: "路径动画_双击_自由路径_完成绘制"
        },
        save: {
          category: "route_animation",
          action: "click_path_confirm",
          label: "路径动画_点击_自由路径_完成添加"
        }
      },
      isShow: false,
      type: "line", //bessel
      status: "paint", // 操作在哪一步骤 (paint画, edit编辑, play播放)
      sprite: null, // 当前选中的元素,也是设置路径动画的元素
      dragHandle: false, // 是否处于鼠标拖动中
      pos: {
        // 操作层在画布编辑层上,所以存在偏移位置
        x: 0,
        y: 0
      },
      firstP: [0, 50], // 第一个点的位置
      point: [], // 所有点的集合 格式为[x1,y1,x2,y2,x3,y3]风别为,左边,中间,右边点位置
      pointC: [], // 拖动点的临时变化盒子
      lineDom: null, // 所有曲线的左边到右边点的直线
      pathDom: null, // 路径path对象
      mpos: null, // 拖动开始的一系列需要留住的属性的集合
      action: "", // 拖动的对象为什么动作
      pIndex: -1, // 选中的点,由于用数组表示集合,值为数组下标
      pathZ: false, // 是否为闭合
      adsorbArr: [], // 吸附所要对其的数据 分奇偶
      adsorbData: null, // 正在吸附中的数据
      middleData: {
        // 横向吸附的辅助线的样式
        show: false,
        width: 0,
        top: 0,
        left: 0
      },
      centerData: {
        // 纵向吸附的辅助线的样式
        show: false,
        height: 0,
        top: 0,
        left: 0
      },
      animFrame: null, // 为了播放和停止存在
      contentHTML: "", // 元素dom的html对象
      content: {
        // 元素的属性
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        opacity: 0,
        rotate: 0,
        flip: 0
      },
      scale: 1 // 为了画布缩放后的点的缩放
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "Tool_Size",
      "MaterialPane_Size",
      "TopNav_Size",
      "SetPanel_Size",
      "TOOL",
      "SelectSprites_Msg"
    ]),
    pathCanvasStyle() {
      const style = {};
      style.width = this.Tool_Size.width + "px";
      style.height = this.Tool_Size.height - 40 + "px";
      style.top = this.TopNav_Size.height + 40 + "px";
      style.left = this.MaterialPane_Size.width + "px";
      return style;
    },
    middleStyle() {
      const style = {};
      style.width = this.middleData.width + "px";
      style.top = this.middleData.top + "px";
      style.left = this.middleData.left + "px";
      return style;
    },
    centerStyle() {
      const style = {};
      style.height = this.centerData.height + "px";
      style.top = this.centerData.top + "px";
      style.left = this.centerData.left + "px";
      return style;
    },
    contentStyle() {
      const style = {};
      style.width = this.content.width + "px";
      style.height = this.content.height + "px";
      style.top = this.content.top + "px";
      style.left = this.content.left + "px";
      style.opacity = this.content.opacity;
      style.transform =
        "rotate(" +
        this.content.rotate +
        "deg)" +
        (this.content.flip ? " scaleX(-1)" : "");
      return style;
    },
    buttonBoxStyle() {
      const style = {};
      style.top = this.TopNav_Size.height + this.TOOL.fixTop - 5 + "px";
      style.left = this.MaterialPane_Size.width + this.TOOL.fixLeft + "px";
      return style;
    },
    boxExitStyle() {
      const style = {};
      style.top = this.TopNav_Size.height + this.TOOL.fixTop - 5 + "px";
      style.right = this.SetPanel_Size.width + this.TOOL.fixLeft + "px";
      return style;
    }
  },
  watch: {
    "TOOL.clientWidth"(val, oldVal) {
      this.changeSize();
    },
    "TOOL.clientHeight"(val, oldVal) {
      this.changeSize();
    }
  },
  mounted() {
    this.$bus.on("set_path_anim", data => {
      // 打开关闭事件
      if (data.action === "paint") {
        this.status = data.action;
        this.init(data.pathAnim);
        this.$bus.emit("FeaturesPop_close_vue", { type: 3 });
      } else if (data.action === "edit") {
        this.isShow = true;
        this.status = data.action;
        this.init(data.data);
        this.$bus.emit("FeaturesPop_close_vue", { type: 3 });
      } else if (data.action === "close" || data.action === "init") {
        this.isShow && this.cancel();
      } else if (data.action === "undo") {
        // 撤销和恢复没办法在undo.vue中完成
        if (data.type === "redo_paintZ") {
          this.pathZ = true;
          this.status = "edit";
          this.freePathSvg(this.point);
          for (let val of this.point) {
            this.linePathSvg(val, true);
          }
        } else if (data.type === "undo_paintZ") {
          this.pathZ = false;
          this.status = "paint";
          this.freePathSvg(this.point);
          this.lineDom.clear();
        } else if (data.type === "undo_paintDb") {
          this.status = "paint";
          this.point.length = 1;
          this.freePathSvg();
          this.lineDom.clear();
        } else if (data.type === "redo_paintDb") {
          this.status = "edit";
          this.point = $.extend(true, [], data.data);
          this.pathZ = false;
          this.freePathSvg();
          this.lineDom.clear();
          for (let i = 0; i < this.point.length; i++) {
            this.linePathSvg(this.point[i], true);
          }
        } else if (data.type === "editMove") {
          this.$set(this.point, data.pIndex, data.data);
          this.freePathSvg();
          this.type === "bessel" && this.updateLineSvg(data.pIndex, data.data);
        } else if (data.type === "freePathType") {
          this.changeType(data.data);
          if (this.status === "paint") {
            this.lineDom.clear();
          }
        } else if (data.type === "savePath") {
          this.$bus.emit("set_path_anim", {
            action: "init",
            pathAnim: data.data
          });
        } else if (data.type === "delPoint") {
          this.point.splice(data.pIndex, 0, [].concat(data.data));
          this.freePathSvg();
          this.lineDom.clear();
          for (let i = 0; i < this.point.length; i++) {
            this.linePathSvg(this.point[i], true);
          }
        } else if (data.type === "redo_delPoint") {
          this.pIndex = data.pIndex;
          this.deletePoint();
        }
      }
    });
    this.$bus.on("keycode_space", data => {
      if (!this.isShow) return;
      if (this.status === "edit") {
        this.play();
      } else if (this.status === "play") {
        this.play(true);
      }
    });
    this.$bus.on("keycode_delete", data => {
      if (this.isShow && this.status === "edit") {
        this.deletePoint(true);
      }
    });
    this.$bus.on("keycode_esc", data => {
      this.isShow && this.exit();
    });
  },
  methods: {
    init(data) {
      // 属性赋值,也是所有的入口
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        this.sprite = this.SelectSprites_Msg[0];
        this.scale = this.TOOL.scale;
        this.isShow = true;
        this.pos.x = this.MaterialPane_Size.width;
        this.pos.y = this.TopNav_Size.height + 40;
        this.pathZ = false;
        this.firstP = [
          this.sprite.positionLeft + this.sprite.width / 2 + this.TOOL.fixLeft,
          this.sprite.positionTop + this.sprite.height / 2 + this.TOOL.fixTop
        ];
        this.initSvgDom();
        if (this.status === "paint") {
          this.point.push(this.firstP.concat(this.firstP.concat(this.firstP)));
        } else if (this.status === "edit") {
          let point;
          if (data) {
            point = data;
          } else {
            point = this.sprite.effect.pathAnim.info.points;
            this.type = this.sprite.effect.pathAnim.info.freePathType;
          }
          // 路径开始点保持和第一个的点一样
          let x = point[0][2] - this.firstP[0],
            y = point[0][3] - this.firstP[1],
            po = [];

          point.forEach((v, i) => {
            po[i] = [];
            for (let j in v) {
              if (j % 2) {
                po[i][j] = v[j] - y;
              } else {
                po[i][j] = v[j] - x;
              }
            }
            this.linePathSvg(po[i], true);
          });
          this.point = po;
          this.freePathSvg(po);
        }
        let dom = this.sprite
          .getThumbnail("freePath")
          .css({ width: "100%", height: "100%" });
        if (this.sprite.type === "Text") {
          dom.css({
            fontSize: this.sprite.font.fontSize + "px",
            fontFamily: `"${this.sprite.font.fontFamilyUrl.split("/").pop()}"`,
            fontWeight: this.sprite.font.fontWeight,
            fontStyle: this.sprite.font.fontStyle,
            textDecoration: this.sprite.font.textDecoration,
            textAlign: this.sprite.font.textAlign,
            color: this.sprite.font.color,
            opacity: this.sprite.font.opacity,
            overflow: "visible"
          });
          dom
            .children("div")
            .attr({ class: "text-clip" })
            .css({
              transform: "scale(" + 1 / this.TOOL.scale + ")",
              transformOrigin: "0px 0px 0px",
              wordBreak: "break-word",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              lineHeight: this.sprite.lineHeight,
              letterSpacing:
                parseFloat(
                  this.sprite.letterSpacing *
                    ~~(parseInt(this.sprite.font.fontSize) / 10) || 0
                ) + "px",
              writingMode: this.sprite.font.writingMode,
              filter: this.sprite.dropShadow
                ? `drop-shadow(${this.sprite.getShadowCss("dropShadow")})`
                : ""
            })
            .css(this.sprite.artStyle || {});
          if (this.sprite.versionAnyway !== "Vertical") {
            dom.children("div").css({
              width: this.sprite.width * this.TOOL.scale,
              height: "auto"
            });
          } else {
            dom.children("div").css({
              width: "auto",
              height: this.sprite.height * this.TOOL.scale
            });
          }
        }
        this.content = {
          width: this.sprite.width,
          height: this.sprite.height,
          top: this.firstP[1] - this.sprite.height / 2,
          left: this.firstP[0] - this.sprite.width / 2,
          rotate: this.sprite.rotate,
          flip: this.sprite.flip,
          opacity: this.sprite.opacity
        };
        this.contentHTML = dom.prop("outerHTML");
        if (this.sprite.border) {
          let ratio = this.sprite.width / this.sprite.height,
            radius = [],
            str = "";
          for (i in this.sprite.border.radius) {
            radius.push(this.sprite.border.radius[i] * ratio);
          }
          str =
            this.sprite.border.radius.join("% ") +
            "% / " +
            radius.join("% ") +
            "%";
          if (this.$refs["currentContent"]) {
            this.$refs["currentContent"].style.overflow = "hidden";
            this.$refs["currentContent"].style.borderRadius = str;
          }
        } else {
          if (this.$refs["currentContent"]) {
            this.$refs["currentContent"].style.overflow = "";
            this.$refs["currentContent"].style.borderRadius = "";
          }
        }
        if (this.sprite.boxShadow) {
          let str1 = this.sprite.getShadowCss("boxShadow");
          this.$refs["currentContent"].style.boxShadow = str1;
        } else {
          this.$refs["currentContent"].style.boxShadow = "";
        }
        this.$nextTick(() => {
          this.handleCrop();
        });
        // 快捷键切换到自由路径模式下(正常为editor)
        this.$store.commit("toggle_shortcutType", "freePathEdit");
      } else {
        this.isShow = false;
        this.sprite = null;
        this.pathDom = null;
        this.lineDom = null;
        this.$store.commit("toggle_shortcutType", "editor");
      }
    },
    initSvgDom() {
      // 初始化SVG(?优化-->没必要每次清空dom在新建,不过这样pathDom没办法情况了:内存换速度)
      $("#freePathEdit").empty();
      let svgDom = SVG("freePathEdit").size(
        this.Tool_Size.width,
        this.Tool_Size.height - 40
      );
      this.pathDom = svgDom.group();
      this.pathDom.path("").attr({
        fill: "none",
        stroke: "#464161",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": 2,
        "stroke-dasharray": "6,6"
      });
      this.lineDom = svgDom.group();
      svgDom = null;
    },
    dragDown(dis, action, handle) {
      this.dragHandle = false;
      if (this.status === "paint") {
        let px = dis.x - this.pos.x,
          py = dis.y - this.pos.y;
        if (action === "firstPoint" && this.point.length > 1) {
          // 如果是第一个点,且大于2个点,直接完成绘制
          this.pathZ = true;
          this.status = "edit";
          this.freePathSvg(this.point);
          for (let val of this.point) {
            this.linePathSvg(val, true);
          }
          eve("undo_redo", null, {
            type: "path_paintPathZ"
          });
        }
        this.pointC = [px, py, px, py, px, py];
      } else if (this.status === "edit") {
        if (!action) return;
        let actionS = action.split("-");
        this.action = actionS[0];
        this.pIndex = +actionS[1];
        this.mpos = {
          x: dis.x,
          y: dis.y,
          arr: [].concat(this.point[this.pIndex])
        };
        this._getAdsorbArr();
      }
    },
    dragMove(dis, action, handle) {
      this.dragHandle = true;
      if (this.status === "paint") {
        let px2 = dis.x - this.pos.x,
          py2 = dis.y - this.pos.y;
        let { x: px0, y: py0 } = this.symmetryP(
          px2,
          py2,
          this.pointC[2],
          this.pointC[3]
        );
        this.pointC = [px0, py0, this.pointC[2], this.pointC[3], px2, py2];
        this.linePathSvg(this.pointC);
        this.freePathSvg(this.point.concat([this.pointC]));
      } else if (this.status === "edit") {
        if (!this.action) return;
        let change = null,
          change1 = null,
          changeA = [],
          arr = this.mpos.arr;
        if (this.action === "pointLeft") {
          change = {
            x: arr[0] + dis.x - this.mpos.x,
            y: arr[1] + dis.y - this.mpos.y
          };
          change1 = this.symmetryP(change.x, change.y, arr[2], arr[3]);
          changeA = [change.x, change.y, arr[2], arr[3], change1.x, change1.y];
        } else if (this.action === "pointRight") {
          change = {
            x: arr[4] + dis.x - this.mpos.x,
            y: arr[5] + dis.y - this.mpos.y
          };
          change1 = this.symmetryP(change.x, change.y, arr[2], arr[3]);
          changeA = [change1.x, change1.y, arr[2], arr[3], change.x, change.y];
        } else if (this.action === "pointCenter") {
          if (this.pIndex === 0) return;
          change = {
            x: this.mpos.x - dis.x,
            y: this.mpos.y - dis.y
          };
          this.adsorbData = this._splitAdsorbArr([
            arr[2] - change.x,
            arr[3] - change.y
          ]);
          let pos = this._getAdsorbPos(this.adsorbData);

          if (typeof pos.x === "number") change.x = arr[2] - pos.x;
          if (typeof pos.y === "number") change.y = arr[3] - pos.y;
          changeA = [
            arr[0] - change.x,
            arr[1] - change.y,
            arr[2] - change.x,
            arr[3] - change.y,
            arr[4] - change.x,
            arr[5] - change.y
          ];
        }
        this.$set(this.point, this.pIndex, changeA);
        this.freePathSvg();
        this.type === "bessel" && this.updateLineSvg(this.pIndex, changeA);
      }
    },
    dragUp(dis, action, handle) {
      if (this.status === "paint") {
        this.point.push(this.pointC);
        this.freePathSvg();
        this.lineDom.clear();
        if (this.dragHandle && this.type === "bessel")
          this.$analysis(this.ANALYSIS.drag);
      } else if (this.status === "edit") {
        if (this.action) {
          eve("undo_redo", null, {
            type: "path_editMove",
            data: {
              scale: this.TOOL.scale,
              pIndex: this.pIndex,
              reData: [].concat(this.mpos.arr),
              data: [].concat(this.point[this.pIndex])
            }
          });
        }
        this.action = "";
        this.middleData.show = false;
        this.centerData.show = false;
      }
      this.dragHandle = handle;
    },
    controlMove(e) {
      // 鼠标移动事件(没有拖动下patn也会由于移动而绘制)
      if (this.status !== "paint") return;
      let px2 = e.pageX - this.pos.x,
        py2 = e.pageY - this.pos.y;
      if (!this.dragHandle) {
        this.freePathSvg(this.point.concat([[px2, py2, px2, py2, px2, py2]]));
      }
    },
    controlDbClick() {
      // 双击确定点退出绘制模式进入编辑模式
      if (this.status !== "paint") return;
      this.status = "edit";
      this.point.pop();
      this.pathZ = false;
      this.freePathSvg();
      this.lineDom.clear();
      for (let i = 0; i < this.point.length; i++) {
        this.linePathSvg(this.point[i], true);
      }
      eve("undo_redo", null, {
        type: "path_paintDb",
        data: {
          scale: this.TOOL.scale,
          data: $.extend(true, [], this.point)
        }
      });
      this.$analysis(this.ANALYSIS.finish);
    },
    freePathSvg(data) {
      // 绘画path
      let path = "";
      let point = data || this.point;
      path = this.getPath(point);
      this.pathDom.first().attr({
        d: path
      });
    },
    linePathSvg(data, clear) {
      // 绘制左右操作点连线
      if (this.type === "line") return;
      let path = "";
      !clear && this.lineDom.clear();
      path = "M" + data.join(",");
      this.lineDom.path(path).attr({
        fill: "none",
        stroke: "rgb(254, 27, 253)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": 1
      });
    },
    updateLineSvg(i, data) {
      // 更新左右操作点连线
      if (this.type === "line") return;
      let path = "";
      path = "M" + data.join(",");
      this.lineDom.get(i).attr({
        d: path
      });
    },
    getPath(point) {
      // 获取path路径属性(包括直线,曲线,是否闭合)
      let path = "";
      if (this.type === "line") {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`;
          } else {
            path += ` ${e[2]} ${e[3]}`;
          }
        });
        if (this.pathZ && point.length > 2) {
          path += ` ${point[0][2]} ${point[0][3]} Z`;
        }
      } else {
        point.forEach((e, i) => {
          if (i === 0) {
            path = `M ${e[2]} ${e[3]}`;
          } else {
            path += ` C ${point[i - 1][4]} ${point[i - 1][5]} ${e[0]} ${e[1]} ${
              e[2]
            } ${e[3]}`;
          }
        });
        if (this.pathZ) {
          path += ` C ${point[point.length - 1][4]} ${
            point[point.length - 1][5]
          } ${point[0][0]} ${point[0][1]} ${point[0][2]} ${point[0][3]} Z`;
        }
      }
      return path;
    },
    symmetryP(x1, y1, x0, y0) {
      // 获取x1对于x0的对称点
      return {
        x: 2 * x0 - x1,
        y: 2 * y0 - y1
      };
    },
    _getAdsorbArr: function() {
      // 获取需要判断吸附的数据
      var adsorbArr = [];
      this.point.forEach((e, i) => {
        if (i !== this.pIndex) {
          adsorbArr.push(e[2], e[3]);
        }
      });
      this.adsorbArr = adsorbArr;
    },
    _getAdsorbPos(arr) {
      // 移动吸附到当前出现的辅助线
      var pos = {};
      var _this = this;
      arr.forEach(function(val, i) {
        if (val.v) {
          if ((i + 2) % 2 === 0) {
            pos.x = val.v;
            pos.p1 = val.p1;
            pos.p2 = val.p2;
          } else {
            pos.y = val.v;
            pos.p3 = val.p1;
            pos.p4 = val.p2;
          }
        }
      });
      this._showNetLine(pos);
      return pos;
    },
    _splitAdsorbArr(arr) {
      // 获取需要判断吸附的数据，并分为两组，分别为垂直线和水平线
      let Arr1 = this.adsorbArr,
        Arr2 = [],
        Arr3 = [];
      Arr1.forEach(function(k, i) {
        if ((i + 2) % 2 === 0) {
          Arr2.push(k);
        } else {
          Arr3.push(k);
        }
      });
      return this._compareArr(arr, Arr2, Arr3);
    },
    _compareArr(arr1, arr2, arr3) {
      // 获取这个元素在变化的时候需要吸附的信息
      let data = [{}, {}],
        _arguments = arguments;
      arr1.forEach(function(k, i) {
        var index = 2;
        if ((i + 2) % 2 === 0) index = 1;
        _arguments[index].forEach(function(v, j) {
          if (Math.floor(Math.abs(k - v) / 5) === 0) {
            data[i].v = v;
            data[i].p1 = _arguments[-index + 3][j];
            data[i].p2 = arr1[-i + 1];
          }
        });
      });
      return data;
    },
    _showNetLine(pos) {
      // 辅助线的显示
      this.middleData.show = false;
      this.centerData.show = false;
      // 宽和高多出40px,上下左右各20px
      if (typeof pos.y === "number") {
        this.middleData.show = true;
        this.middleData.left = Math.min(pos.p3, pos.p4) - 20;
        this.middleData.width = 40 + Math.abs(pos.p3 - pos.p4);
        this.middleData.top = pos.y;
      }
      if (typeof pos.x === "number") {
        this.centerData.show = true;
        this.centerData.top = Math.min(pos.p1, pos.p2) - 20;
        this.centerData.height = 40 + Math.abs(pos.p1 - pos.p2);
        this.centerData.left = pos.x;
      }
    },
    deletePoint(undo) {
      // 删除点的操作
      if (this.pIndex > 0 && this.point.length > 2) {
        let undoData = {
          pIndex: this.pIndex,
          reData: [],
          scale: this.TOOL.scale
        };
        undoData.reData = [].concat(this.point.splice(this.pIndex, 1)[0]);
        let lineDom = this.lineDom.get(this.pIndex);
        lineDom && lineDom.remove();
        this.freePathSvg();
        this.pIndex--;
        undo &&
          eve("undo_redo", null, { type: "path_delPoint", data: undoData });
      }
    },
    changeType(type, undo) {
      // 更改线的属性(bessel, line)
      if (type === this.type) return;
      if (undo) {
        eve("undo_redo", null, {
          type: "path_freePathType",
          data: {
            reData: this.type,
            data: type
          }
        });
        this.$analysis(this.ANALYSIS[type]);
      }
      this.type = type;
      this.freePathSvg();
      if (type === "line") {
        this.lineDom.clear();
      } else {
        for (let val of this.point) {
          this.linePathSvg(val, true);
        }
      }
    },
    savePath() {
      // 保存路径退出(设置自由路径在setPathAnim部分)
      if (!this.pathDom) return;
      let undoData = {
        spriteId: this.sprite.id,
        scenesId: this.sprite.scenesId,
        reData: this.sprite.effect.getPathAnim(),
        scale: this.TOOL.scale
      };
      let data = { type: "FreePath", info: {}, target: null },
        bbox = this.pathDom.bbox();
      data.target = this._getTargetInfo();
      data.info.width = bbox.w;
      data.info.height = bbox.h;
      data.info.rotate = 0;
      data.info.path = null;
      data.info.points = this._getPointData(bbox);
      data.info.close = this.pathZ;
      data.info.freePathType = this.type;

      undoData.data = $.extend(true, {}, data);

      this.$bus.emit("set_path_anim", {
        action: "init",
        pathAnim: data
      });

      eve("undo_redo", null, { type: "path_savePath", data: undoData });
      this.cancel();
      this.$analysis(this.ANALYSIS.save);
    },
    _getTargetInfo() {
      // 获取target
      let change = {
        x: 0,
        y: 0
      };
      if (!this.pathZ) {
        change.x = this.point[this.point.length - 1][2] - this.firstP[0];
        change.y = this.point[this.point.length - 1][3] - this.firstP[1];
      }
      let target = {
        w: this.sprite.width,
        h: this.sprite.height,
        rotate: this.sprite.rotate,
        x: this.sprite.positionLeft + change.x,
        y: this.sprite.positionTop + change.y
      };
      return target;
    },
    _getPointData(bbox) {
      // 获取正确的point点,以保证路径bbox的x,y为0
      let po = [];
      this.point.forEach((v, i) => {
        po[i] = [];
        for (let j in v) {
          if (j % 2) {
            po[i][j] = v[j] - bbox.y;
          } else {
            po[i][j] = v[j] - bbox.x;
          }
        }
      });
      return po;
    },
    cancel(undo) {
      // 关闭自由路径操作
      let undoData = {};
      if (undo) {
        undoData.spriteId = this.sprite.id;
        undoData.scenesId = this.sprite.scenesId;
        undoData.reData = $.extend(true, [], this.point);
        undoData.scale = this.TOOL.scale;
      }
      this.isShow = false;
      this.pIndex = -1;
      this.lineDom = null;
      this.pathDom = null;
      this.sprite = null;
      this.point = [];
      undo && eve("undo_redo", null, { type: "path_exitEdit", data: undoData });
      this.$store.commit("toggle_shortcutType", "editor");
      this.$bus.emit("set_path_anim", { action: "close" });
    },
    play(stop) {
      // 播放和暂停播放
      if (stop) {
        window.cancelAnimationFrame(this.animFrame);
        this.content.left = this.firstP[0] - this.content.width / 2;
        this.content.top = this.firstP[1] - this.content.height / 2;
        this.status = "edit";
        this.lineDom.show();
        return;
      }
      let dom = this.pathDom.first();
      let length = dom.length();
      let start = 0,
        sn = Math.round(length / 60 / 4),
        pos = null,
        step = null,
        animFrame = null;
      this.lineDom.hide();
      this.status = "play";

      step = timestamp => {
        start += sn;
        if (start <= length) {
          pos = dom.pointAt(start);
          this.content.left = pos.x - this.content.width / 2;
          this.content.top = pos.y - this.content.height / 2;
          this.animFrame = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(this.animFrame);
          this.content.left = this.firstP[0] - this.content.width / 2;
          this.content.top = this.firstP[1] - this.content.height / 2;
          this.status = "edit";
          this.lineDom.show();
        }
      };

      this.animFrame = window.requestAnimationFrame(step);
    },
    exit() {
      // 退出自由路径操作
      if (this.status === "paint") {
        if (this.point.length > 1) {
          this.status = "edit";
          this.freePathSvg(this.point);
          for (let i = 0; i < this.point.length; i++) {
            this.linePathSvg(this.point[i], true);
          }
          eve("undo_redo", null, {
            type: "path_paintDb",
            data: $.extend(true, [], this.point)
          });
        } else {
          this.isShow = false;
          this.$bus.emit("set_path_anim", { action: "close" });
        }
      } else if (this.status === "edit") {
        this.cancel(true);
      }
    },
    changeSize() {
      // 画布尺寸变化后的对应操作
      if (!this.isShow) return;
      let scale = this.scale / this.TOOL.scale;
      this.pos.x = this.MaterialPane_Size.width;
      this.pos.y = this.TopNav_Size.height + 40;
      this.initSvgDom();
      this._scaleArr(this.firstP, scale);
      this._scaleArrTwo(this.point, scale);
      this.scale = this.TOOL.scale;
      this.freePathSvg();
      this.content.width *= scale;
      this.content.height *= scale;
      this.content.top *= scale;
      this.content.left *= scale;
      if (this.sprite.type === "Text") {
        $(".sprite-content .content>div>div").css({
          transform: "scale(" + 1 / this.TOOL.scale + ")"
        });
      }
    },
    _scaleArr: function(arr, scale) {
      // 单个点集合的缩放
      if (!arr) return;
      for (var i = 0; i < arr.length; i++) {
        arr[i] *= scale;
      }
      return arr;
    },
    _scaleArrTwo: function(arr, scale) {
      // 多个点集合的缩放
      if (!arr) return;
      for (var i = 0; i < arr.length; i++) {
        arr[i].forEach(function(v, j) {
          arr[i][j] = v *= scale;
        });
        this.status === "edit" && this.linePathSvg(arr[i], true);
      }
      return arr;
    },
    handleCrop() {
      let cropBoxData = (this.sprite || {}).cropBoxData;
      if (!this.sprite || this.sprite.cropType !== "free") {
        return;
      }
      let moveEl = this.$refs["currentContent"];
      if (!moveEl) {
        return;
      }
      let wrapper = $(moveEl.children[0]);
      let image = wrapper.children().eq(0);
      let sprite = this.sprite;
      let nextW = wrapper.width();
      let nextH = wrapper.height();
      var ratioH = nextH / cropBoxData.height;
      var ratioW = nextW / cropBoxData.width;
      var nextCrop = {
        width: nextW,
        height: nextH,
        top: cropBoxData.top * ratioH,
        left: cropBoxData.left * ratioW,
        originWidth: cropBoxData.originWidth * ratioW,
        originHeight: cropBoxData.originHeight * ratioH,
        deltaX: cropBoxData.deltaX * ratioW,
        deltaY: cropBoxData.deltaY * ratioH,
        rotation: cropBoxData.rotation,
        deltaRotation: cropBoxData.deltaRotation,
        innerRotation: cropBoxData.innerRotation
      };

      image.show();
      wrapper.find(".crop-inner-ref").remove();

      wrapper.css({
        position: "relative",
        overflow: "hidden"
      });
      image.css({
        position: "absolute",
        left: nextW / 2 + nextCrop.deltaX - nextCrop.originWidth / 2,
        top: nextH / 2 + nextCrop.deltaY - nextCrop.originHeight / 2,
        width: nextCrop.originWidth,
        height: nextCrop.originHeight,
        maxWidth: nextCrop.originWidth,
        transform: "rotate(" + nextCrop.deltaRotation + "deg)"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.freePath-edit {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
}
.mask-all {
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
}
.path-canvas {
  position: relative;
  background-color: rgba(255, 255, 255, 0.5);
}
#setFreePath,
.free-path-control,
.path-preview {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.free-path-control {
  overflow: hidden;
  z-index: 10;

  div.first-point {
    position: absolute;
    width: 9px;
    height: 9px;
    border: 1px solid #fe1bfd;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.point-box {
  position: absolute;
  top: 0;
  left: 0;

  > div {
    position: absolute;
    top: 0;
    left: 0;

    > div {
      position: absolute;
      width: 9px;
      height: 9px;
      box-sizing: border-box;
    }
  }

  .left-point,
  .right-point {
    border-radius: 50%;
    background-color: #fe1bfd;
    cursor: move;
  }
  .center-point {
    border: 2px solid #fe1bfd;
    cursor: move;
  }
  .center-point.active {
    background-color: #fe1bfd;
  }
}
.auxiliary_line_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  div {
    position: absolute;
    opacity: 0.6;
  }

  div:nth-child(even) {
    height: 100%;
    width: 1px;
    border-left: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: "";
      border-left: 1px dashed #fe1bfd;
      height: 100%;
      width: 1px;
      left: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
  div:nth-child(odd) {
    width: 100%;
    height: 1px;
    border-top: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: "";
      border-top: 1px dashed #fe1bfd;
      height: 1px;
      width: 100%;
      top: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
}
.button-box {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 130px;
  height: 38px;
  color: #666666;
  border: 1px solid #dcdff2;
  border-radius: 4px;
  z-index: 40;

  div {
    border-radius: 4px;
    width: 65px;
    line-height: 36px;
    background-color: #faf9fe;
  }

  .tip-icon {
    position: absolute;
    top: 7px;
    right: -50px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    color: #fff;
    background-color: #474261;
    border-radius: 50%;
    cursor: pointer;
  }

  .active {
    border-color: #5778fb;
    background-color: #5778fb;
    color: #fff;
  }
}
.box-exit {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 170px;
  height: 38px;
  color: #666666;
  z-index: 40;

  div {
    border: 1px solid #dcdff2;
    border-radius: 4px;
    width: 80px;
    line-height: 36px;
    background-color: #faf9fe;
  }

  .active {
    border-color: #5778fb;
    background-color: #5778fb;
    color: #fff;
  }
}
.sprite-content {
  position: absolute;
  display: flex;

  .content {
    width: 100%;
    height: 100%;
    line-height: normal;
  }
}
.playing {
  z-index: 50;
}
#freePathEdit {
  position: absolute;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/freePathEdit.vue